export enum CommentCodeType {
  READING_FAILURE_REASON = 'READING_FAILURE_REASON',
  REPORT = 'REPORT',
}

export interface CommentCodeModel {
  id: number;
  type: CommentCodeType;
  utilityType: string;
  code: string;
  value: string;
  order: number;
  isPhotoRequired: boolean;
  minPhoto: number;
  maxPhoto: number;
  isFinal: boolean;
  validForConsumptionPlace: boolean;
  validForDevice: boolean;
  validForConsumptionMeter: boolean;
  isActive: boolean;
  isCommentRequired: boolean;
  taskType: string;
  cardRequired: boolean;
  readingAvailable: boolean;
  lowConsumption: boolean;
  noConsumption: boolean;
  normalConsumption: boolean;
  highConsumption: boolean;
  sourceId: number;
}
